import React from 'react';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { connect } from 'react-redux';
import {Card, CardHeader, CardText} from 'material-ui/Card';
import excelImg from 'Content/Assets/images/excel-icon_20.png';
import pdfImg from 'Content/Assets/images/PDF_original.png';
import FlatButton from 'material-ui/FlatButton';
import Avatar from 'material-ui/Avatar';
import styles from './styles/DownloadModalStyles';
import * as cookieServices from 'services/cookies/cookieServices';
import ButtonLoaderWithText from 'components/loaders/ButtonLoaderWithText';
import { downloadListExcel, downloadAllListExcel, downloadListPdf, downloadAllListPdf, downloadListCsv, downloadAllListCsv } from 'actions/crashboxxServicesActions';

class DownloadModal extends React.Component {
    constructor(props){
        super(props);

        this.handleDownloadAllListExcel = this.handleDownloadAllListExcel.bind(this);
        this.handleDownloadAllListPdf = this.handleDownloadAllListPdf.bind(this);
        this.handleDownloadAllListCsv = this.handleDownloadAllListCsv.bind(this);

        this.handleDownloadListExcel = this.handleDownloadListExcel.bind(this);
        this.handleDownloadListCsv = this.handleDownloadListCsv.bind(this);
        this.handleDownloadListPdf = this.handleDownloadListPdf.bind(this);
    }

    handleDownloadAllListExcel(){
        if(this.props.isExcelAllListLoading) return;
        var searchData = cookieServices.getSeachFilters();
        this.props.downloadAllListExcel(searchData, this.props.isIcnPlus, this.props.isDent);
    }

    handleDownloadAllListPdf(){
        if(this.props.isPdfAllListLoading) return;
        var searchData = cookieServices.getSeachFilters();
        this.props.downloadAllListPdf(searchData, this.props.isIcnPlus, this.props.isDent);
    }

    handleDownloadAllListCsv(){
        if(this.props.isCsvAllListLoading) return;
        var searchData = cookieServices.getSeachFilters();
        this.props.downloadAllListCsv(searchData, this.props.isIcnPlus, this.props.isDent);
    }

    handleDownloadListExcel(){
        if(!this.props.selectedDataList || this.props.selectedDataList.length <= 0) return;
        this.props.downloadListExcel(this.props.selectedDataList, this.props.isIcnPlus, this.props.isDent);
    }

    handleDownloadListPdf(){
        if(!this.props.selectedDataList || this.props.selectedDataList.length <= 0) return;
        this.props.downloadListPdf(this.props.selectedDataList, this.props.isIcnPlus, this.props.isDent);
    }

    handleDownloadListCsv(){
        if(!this.props.selectedDataList || this.props.selectedDataList.length <= 0) return;
        this.props.downloadListCsv(this.props.selectedDataList, this.props.isIcnPlus, this.props.isDent);
    }

    render() {
        console.info("download modal rendered");

        const {translate, totalCount, isPdfAllListLoading, isExcelAllListLoading, isCsvAllListLoading,
            isExcelListLoading, isPdfListLoading, isCsvListLoading, selectedDataList } = this.props;
        return (
            <div>
                <Card expanded={true}>
                <CardHeader
                    title={translate('Download.downloadAll', { count: totalCount })}
                    />

                    <CardText expandable={true}>
                        {
                            isPdfAllListLoading ? <ButtonLoaderWithText />
                            :
                            <FlatButton label={translate('Download.downloadPDF')}
                                onClick={this.handleDownloadAllListPdf}
                                icon={ <Avatar
                                        src={pdfImg}
                                        size={25}
                                        style={styles.imageIcon}
                                    /> } >
                            </FlatButton>
                        }
                        {
                            isExcelAllListLoading ? <ButtonLoaderWithText />
                            :
                            <FlatButton label={translate('Download.downloadExcel')}
                                onClick={this.handleDownloadAllListExcel}
                                icon={ <Avatar
                                        src={excelImg}
                                        size={25}
                                        style={styles.imageIcon}
                                    /> } >
                            </FlatButton>
                        }
                        {
                            isCsvAllListLoading ? <ButtonLoaderWithText />
                            :
                            <FlatButton label={translate('Download.downloadCSV')}
                                onClick={this.handleDownloadAllListCsv}
                                icon={ <Avatar
                                            src={excelImg}
                                            size={25}
                                            style={styles.imageIcon}
                                        /> } >
                            </FlatButton>
                        }
                    </CardText>
                </Card>
                {
                    selectedDataList && selectedDataList.length > 0 ?
                    <Card expanded={true}>
                            <CardHeader
                                title={translate('Download.downloadSelected', { count: selectedDataList.length })}
                                />
                            <CardText expandable={true}>
                                {
                                    isPdfListLoading ? <ButtonLoaderWithText />
                                    :
                                    <FlatButton label={translate('Download.downloadPDF')}
                                        onClick={this.handleDownloadListPdf}
                                        icon={ <Avatar
                                                src={pdfImg}
                                                size={25}
                                                style={styles.imageIcon}
                                            /> } >
                                    </FlatButton>
                                }
                                {
                                    isExcelListLoading ? <ButtonLoaderWithText />
                                    :
                                    <FlatButton label={translate('Download.downloadExcel')}
                                        onClick={this.handleDownloadListExcel}
                                        icon={ <Avatar
                                                src={excelImg}
                                                size={25}
                                                style={styles.imageIcon}
                                            /> } >
                                    </FlatButton>
                                }
                                {
                                    isCsvListLoading ? <ButtonLoaderWithText />
                                    :
                                    <FlatButton label={translate('Download.downloadCSV')}
                                        onClick={this.handleDownloadListCsv}
                                        icon={ <Avatar
                                                    src={excelImg}
                                                    size={25}
                                                    style={styles.imageIcon}
                                                /> } >
                                    </FlatButton>
                                }
                            </CardText>
                        </Card>
                    :
                null
                }

            </div>
        );
    }
}

DownloadModal.propTypes = {
    //x: PropTypes.object,
    //x: PropTypes.func,
    //x: PropTypes.bool,
    //x: PropTypes.array.isRequired,
    //x: PropTypes.object.isRequired
}

function mapStateToProps(state, ownProps){

    return {
        translate: getTranslate(state.locale),
        currentLanguage: getActiveLanguage(state.locale).code,

        isExcelListLoading: state.excelList.isLoading,
        isPdfListLoading: state.pdfList.isLoading,
        isCsvListLoading: state.csvList.isLoading,

        isExcelAllListLoading: state.excelAllList.isLoading,
        isPdfAllListLoading: state.pdfAllList.isLoading,
        isCsvAllListLoading: state.csvAllList.isLoading
    }
}
export default connect(mapStateToProps, {downloadListExcel, downloadAllListExcel, downloadListPdf, downloadAllListPdf, downloadListCsv, downloadAllListCsv})(DownloadModal);


// WEBPACK FOOTER //
// ./src/containers/downloadButtons/DownloadModal.js